import React, { useEffect, useState } from 'react';
import { Wrench } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToOffer = () => {
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${isScrolled ? 'bg-[#0a0a0a]/80 backdrop-blur-md border-[#262626] py-3' : 'bg-transparent border-transparent py-5'}`} data-id="element-104">
      <div className="max-w-6xl mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-105">
        <div className="flex items-center gap-2 text-white" data-id="element-106">
          <Wrench className="w-5 h-5 text-[#F59E0B]" data-id="element-107" />
          <span className="font-heading text-xl tracking-wide font-bold" data-id="element-108">
            MECÁNICA BÁSICA
          </span>
        </div>

        <button onClick={scrollToOffer} className="bg-[#F59E0B] hover:bg-[#D97706] text-[#0a0a0a] font-heading font-bold px-5 py-2 rounded-sm text-sm tracking-wider transition-colors" data-id="element-109">
          Comprar Ahora
        </button>
      </div>
    </header>;
}